/**
 * Technical quantities the server only sends to the super-administrator. A call row carries `null`
 * for a quantity the call did not measure (tokens for an audio call, duration for a text call).
 */
class AiCostQuantitiesView {
	readonly inputTokens: number | null;
	readonly outputTokens: number | null;
	readonly cachedInputTokens: number | null;
	readonly cacheWriteTokens: number | null;
	readonly totalTokens: number | null;
	readonly audioSeconds: number | null;

	constructor(payload: {
		readonly inputTokens: number | null;
		readonly outputTokens: number | null;
		readonly cachedInputTokens: number | null;
		readonly cacheWriteTokens: number | null;
		readonly totalTokens: number | null;
		readonly audioSeconds: number | null;
	}) {
		this.inputTokens = payload.inputTokens;
		this.outputTokens = payload.outputTokens;
		this.cachedInputTokens = payload.cachedInputTokens;
		this.cacheWriteTokens = payload.cacheWriteTokens;
		this.totalTokens = payload.totalTokens;
		this.audioSeconds = payload.audioSeconds;

		Object.freeze(this);
	}
}

export default AiCostQuantitiesView;
